<template>
  <div
    @click="$refs.summary && $refs.summary.handleClick()"
    :style="{ width: width + 'px' }"
    class="grid"
  >
    <dropdown-menu
      v-if="field.cid && field.cid.length == 24"
      @click="changeGatherType(field.cid, $event)"
      :menu-list="gatherMenu"
      placement="top"
    >
      <!-- 汇总信息 -->
      <div class="text-wrap">
        <span class="font-main">
          {{ label }}
        </span>
        <span class="font-main label">
          {{ value }}
        </span>
        <i class="el-icon-arrow-down"></i>
      </div>
    </dropdown-menu>
  </div>
</template>

<script>
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import { gatherTypeMap } from "../static"

export default {
  name: "summary-cell",
  components: {
    DropdownMenu
  },
  props: {
    viewId: String,
    field: {
      type: Object,
      default: () => ({})
    },
    colWidth: [String, Number],
    value: String,
    gatherType: String
  },
  computed: {
    label() {
      return gatherTypeMap[this.gatherType] ? gatherTypeMap[this.gatherType] + ":" : ""
    },
    width() {
      return this.colWidth || this.field.width || 60
    },
    gatherMenu() {
      let arr = [{ command: "", title: "不显示" }]
      for (let type in gatherTypeMap) {
        if (this.field.dataType !== "number" && !["FILL", "NOT_FILL"].includes(type)) break
        arr.push({
          command: type,
          title: gatherTypeMap[type]
        })
      }
      return arr
    }
  },
  methods: {
    changeGatherType(cid, gatherType) {
      gatherType = gatherType || null
      this.$emit("change", { cid, gatherType })
    }
  }
}
</script>

<style lang="scss" scoped>
.text-wrap {
  display: inline-block;
  .label {
    color: #303133;
  }
  .el-dropdown {
    .el-icon-arrow-down {
      color: $color-font-second;
    }
  }
}
</style>
